import script from "./TxOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./TxOverlay.vue?vue&type=script&setup=true&lang=js"

import "./TxOverlay.vue?vue&type=style&index=0&id=13c7f342&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c7f342"]])

export default __exports__